{
  "HELP_CENTER": {
    "TITLE": "Help Center",
    "NEW_PAGE": {
      "DESCRIPTION": "Luo itsepalveluohjekeskusportaaleja asiakkaillesi. Auta heitä löytämään vastaukset nopeasti odottamatta. Tehosta tiedustelujen käsittelyä, paranna agenttien tehokkuutta ja nosta asiakaspalvelun tasoa.",
      "CREATE_PORTAL_BUTTON": "Luo portaali"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Nimetön"
    },
    "HEADER": {
      "FILTER": "Suodata",
      "SORT": "Järjestä",
      "LOCALE": "Kieliversio",
      "SETTINGS_BUTTON": "Asetukset",
      "NEW_BUTTON": "Uusi artikkeli",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Julkaistu",
        "DRAFT": "Draft",
        "ARCHIVED": "Arkistoitu"
      },
      "TITLES": {
        "ALL_ARTICLES": "Kaikki artikkelit",
        "MINE": "Omat artikkelit",
        "DRAFT": "Draft-artikkelit",
        "ARCHIVED": "Arkistoidut artikkelit"
      },
      "LOCALE_SELECT": {
        "TITLE": "Valitse kieliversio",
        "PLACEHOLDER": "Valitse kieliversio",
        "NO_RESULT": "Kieliversiota ei löytynyt",
        "SEARCH_PLACEHOLDER": "Hae kieliversiota"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Kaikki artikkelit",
      "PUBLISH_BUTTON": "Julkaise",
      "MOVE_TO_ARCHIVE_BUTTON": "Siirrä arkistoon",
      "PREVIEW": "Esikatselu",
      "ADD_TRANSLATION": "Lisää käännös",
      "OPEN_SIDEBAR": "Avaa sivupalkki",
      "CLOSE_SIDEBAR": "Sulje sivupalkki",
      "SAVING": "Tallennetaan...",
      "SAVED": "Tallennettu"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Lataa kuva",
        "UPLOADING": "Lähetetään...",
        "SUCCESS": "Kuva ladattu onnistuneesti",
        "ERROR": "Virhe kuvan lataamisessa",
        "UN_AUTHORIZED_ERROR": "Sinulla ei ole oikeutta ladata kuvia",
        "ERROR_FILE_SIZE": "Kuvan koon tulee olla alle {size}Mt",
        "ERROR_FILE_FORMAT": "Kuvan muodon tulee olla jpg, jpeg tai png",
        "ERROR_FILE_DIMENSIONS": "Kuvan mittojen tulee olla alle 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Lisää ankkuri",
        "TITLE": "Lisää ankkuri",
        "SUBMIT": "Lisää",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikkelin asetukset",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategoria",
          "TITLE": "Valitse kategoria",
          "PLACEHOLDER": "Valitse kategoria",
          "NO_RESULT": "Kategoriaa ei löytynyt",
          "SEARCH_PLACEHOLDER": "Hae kategoriaa"
        },
        "AUTHOR": {
          "LABEL": "Kirjoittaja",
          "TITLE": "Valitse kirjoittaja",
          "PLACEHOLDER": "Valitse kirjoittaja",
          "NO_RESULT": "Kirjoittajia ei löytynyt",
          "SEARCH_PLACEHOLDER": "Hae kirjoittajaa"
        },
        "META_TITLE": {
          "LABEL": "Meta-otsikko",
          "PLACEHOLDER": "Lisää meta-otsikko"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta-kuvaus",
          "PLACEHOLDER": "Lisää meta-kuvaus parempien SEO-tulosten saavuttamiseksi..."
        },
        "META_TAGS": {
          "LABEL": "Meta-tunnisteet",
          "PLACEHOLDER": "Lisää meta-tunnisteet pilkulla erotettuna..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arkistoi artikkeli",
        "DELETE": "Poista artikkeli"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Ei kategoriaa",
      "SEARCH_RESULTS": "Hakutulokset haulle {query}",
      "EMPTY_TEXT": "Hae artikkeleita lisätäksesi ne vastauksiin.",
      "SEARCH_LOADER": "Haetaan...",
      "INSERT_ARTICLE": "Lisää",
      "NO_RESULT": "Artikkeleita ei löytynyt",
      "COPY_LINK": "Kopioi artikkelin linkki leikepöydälle",
      "OPEN_LINK": "Avaa artikkeli uudessa välilehdessä",
      "PREVIEW_LINK": "Esikatsele artikkelia"
    },
    "PORTAL": {
      "HEADER": "Portaalit",
      "DEFAULT": "Oletus",
      "NEW_BUTTON": "Uusi portaali",
      "ACTIVE_BADGE": "aktiivinen",
      "CHOOSE_LOCALE_LABEL": "Valitse kieliversio",
      "LOADING_MESSAGE": "Ladataan portaaleja...",
      "ARTICLES_LABEL": "artikkelia",
      "NO_PORTALS_MESSAGE": "Portaaleja ei ole saatavilla",
      "ADD_NEW_LOCALE": "Lisää uusi kieliversio",
      "POPOVER": {
        "TITLE": "Portaalit",
        "PORTAL_SETTINGS": "Portaalin asetukset",
        "SUBTITLE": "Sinulla on useita portaaleja, ja jokaisella portaalilla voi olla eri kieliversiot.",
        "CANCEL_BUTTON_LABEL": "Peruuta",
        "CHOOSE_LOCALE_BUTTON": "Valitse kieliversio"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artikkelia",
            "ADD": "Lisää kieliversio",
            "VISIT": "Vieraile sivustolla",
            "SETTINGS": "Asetukset",
            "DELETE": "Poista"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portaalin asetukset",
            "ITEMS": {
              "NAME": "Nimi",
              "DOMAIN": "Mukautettu verkkotunnus",
              "SLUG": "Slug",
              "TITLE": "Portaalin otsikko",
              "THEME": "Teemaväri",
              "SUB_TEXT": "Portaalin alateksti"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Saatavilla olevat kieliversiot",
            "TABLE": {
              "NAME": "Kieliversion nimi",
              "CODE": "Kielikoodi",
              "ARTICLE_COUNT": "Artikkeleiden määrä",
              "CATEGORIES": "Kategorioiden määrä",
              "SWAP": "Vaihda",
              "DELETE": "Poista",
              "DEFAULT_LOCALE": "Oletus"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Poista portaali",
          "MESSAGE": "Haluatko varmasti poistaa tämän portaalin",
          "YES": "Kyllä, poista portaali",
          "NO": "Ei, säilytä portaali",
          "API": {
            "DELETE_SUCCESS": "Portaali poistettu onnistuneesti",
            "DELETE_ERROR": "Virhe portaalin poistamisessa"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Muokkaa portaalia",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Perustiedot"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portaalin mukauttaminen"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategoriat"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Kieliversiot"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategoriat kohteessa",
          "NEW_CATEGORY": "Uusi kategoria",
          "TABLE": {
            "NAME": "Nimi",
            "DESCRIPTION": "Kuvaus",
            "LOCALE": "Kieliversio",
            "ARTICLE_COUNT": "Artikkeleiden määrä",
            "ACTION_BUTTON": {
              "EDIT": "Muokkaa kategoriaa",
              "DELETE": "Poista kategoria"
            },
            "EMPTY_TEXT": "Kategorioita ei löytynyt"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Päivitä perusasetukset"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Help Centerin tiedot",
            "BODY": "Portaalin perustiedot"
          },
          "CUSTOMIZATION": {
            "TITLE": "Help Centerin mukauttaminen",
            "BODY": "Mukauta portaalia"
          },
          "FINISH": {
            "TITLE": "Noniin! 🎉",
            "BODY": "Kaikki on nyt valmista!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Takaisin",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Luo portaali",
            "TITLE": "Help Centerin tiedot",
            "CREATE_BASIC_SETTING_BUTTON": "Luo portaalin perusasetukset"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portaalin mukauttaminen",
            "TITLE": "Help Centerin mukauttaminen",
            "UPDATE_PORTAL_BUTTON": "Päivitä portaalin asetukset"
          },
          "FINISH_PAGE": {
            "TITLE": "Valmista! 🎉 Kaikki on nyt kunnossa!",
            "MESSAGE": "Voit nyt nähdä luodun portaalin Kaikki portaalit -sivulla.",
            "FINISH": "Siirry Kaikki portaalit -sivulle"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Lataa logo",
          "HELP_TEXT": "Tämä logo näytetään portaalin ylätunnisteessa.",
          "IMAGE_UPLOAD_SUCCESS": "Logo ladattu onnistuneesti",
          "IMAGE_UPLOAD_ERROR": "Logo poistettu onnistuneesti",
          "IMAGE_DELETE_ERROR": "Virhe logon poistamisessa"
        },
        "NAME": {
          "LABEL": "Nimi",
          "PLACEHOLDER": "Portaalin nimi",
          "HELP_TEXT": "Nimeä käytetään sisäisesti julkisessa portaalissa.",
          "ERROR": "Nimi on pakollinen"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portaalin slug URL-osoitteita varten",
          "ERROR": "Slug on pakollinen"
        },
        "DOMAIN": {
          "LABEL": "Mukautettu verkkotunnus",
          "PLACEHOLDER": "Portaalin mukautettu verkkotunnus",
          "HELP_TEXT": "Lisää vain Jos haluat käyttää mukautettua verkkotunnusta portaaleille. Esim: {exampleURL}",
          "ERROR": "Anna kelvollinen verkkotunnuksen URL-osoite"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Etusivun linkki",
          "PLACEHOLDER": "Portaalin etusivun linkki",
          "HELP_TEXT": "Linkki jota käytetään palatakseen portaalista kotisivulle. Esim: {exampleURL}",
          "ERROR": "Anna kelvollinen etusivun URL-osoite"
        },
        "THEME_COLOR": {
          "LABEL": "Portaalin teemaväri",
          "HELP_TEXT": "Tämä väri näkyy portaalin teemavärinä."
        },
        "PAGE_TITLE": {
          "LABEL": "Sivun otsikko",
          "PLACEHOLDER": "Portaalin sivun otsikko",
          "HELP_TEXT": "Sivun otsikkoa käytetään julkisessa portaalissa.",
          "ERROR": "Sivun otsikko on pakollinen"
        },
        "HEADER_TEXT": {
          "LABEL": "Ylätunnisteen teksti",
          "PLACEHOLDER": "Portaalin ylätunnisteen teksti",
          "HELP_TEXT": "Portaalin ylätunnisteen tekstiä käytetään julkisessa portaalissa.",
          "ERROR": "Portaalin ylätunnisteen teksti on pakollinen"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portaali luotu onnistuneesti.",
          "ERROR_MESSAGE_FOR_BASIC": "Portaalia ei voitu luoda. Yritä uudelleen.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portaali päivitetty onnistuneesti.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portaalia ei voitu päivittää. Yritä uudelleen."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Lisää uusi kieliversio",
        "SUB_TITLE": "Tämä lisää uuden kieliversion käännösluetteloosi.",
        "PORTAL": "Portaali",
        "LOCALE": {
          "LABEL": "Kieliversio",
          "PLACEHOLDER": "Valitse kieliversio",
          "ERROR": "Kieliversio on pakollinen"
        },
        "BUTTONS": {
          "CREATE": "Luo kieliversio",
          "CANCEL": "Peruuta"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kieliversio lisätty onnistuneesti",
          "ERROR_MESSAGE": "Kieliversiota ei voitu lisätä. Yritä uudelleen."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Oletuskieliversio päivitetty onnistuneesti",
          "ERROR_MESSAGE": "Oletuskieliversiota ei voitu päivittää. Yritä uudelleen."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Kieliversio poistettu portaalista onnistuneesti",
          "ERROR_MESSAGE": "Kieliversiota ei voitu poistaa portaalista. Yritä uudelleen."
        }
      }
    },
    "TABLE": {
      "404": "Hakuasi vastaavia artikkeleita ei löytynyt 🔍",
      "LOADING_MESSAGE": "Ladataan artikkeleita...",
      "NO_ARTICLES": "Artikkeleita ei ole saatavilla",
      "HEADERS": {
        "TITLE": "Otsikko",
        "CATEGORY": "Kategoria",
        "READ_COUNT": "Katselukerrat",
        "STATUS": "Tila",
        "LAST_EDITED": "Viimeksi muokattu"
      },
      "COLUMNS": {
        "BY": "tekijä",
        "AUTHOR_NOT_AVAILABLE": "Kirjoittajaa ei ole saatavilla"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Ladataan artikkelia...",
      "TITLE_PLACEHOLDER": "Artikkelin otsikko tähän",
      "CONTENT_PLACEHOLDER": "Kirjoita artikkelisi tähän",
      "API": {
        "ERROR": "Virhe artikkelin tallentamisessa"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Virhe artikkelin julkaisemisessa",
        "SUCCESS": "Artikkeli julkaistu onnistuneesti"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Virhe artikkelin arkistoimisessa",
        "SUCCESS": "Artikkeli arkistoitu onnistuneesti"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Virhe artikkelin siirtämisessä Draft-tilaan",
        "SUCCESS": "Artikkeli siirretty Draft-tilaan"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Vahvista poistaminen",
          "MESSAGE": "Haluatko varmasti poistaa artikkelin?",
          "YES": "Kyllä, poista",
          "NO": "Ei, säilytä"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikkeli poistettu onnistuneesti",
        "ERROR_MESSAGE": "Virhe artikkelin poistamisessa"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Lisää artikkelin otsikko ja sisältö, jotta voit päivittää asetukset"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Hae artikkeleita"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Luo kategoria",
        "SUB_TITLE": "Kategoriaa käytetään julkisessa portaalissa artikkeleiden luokitteluun.",
        "PORTAL": "Portaali",
        "LOCALE": "Kieliversio",
        "NAME": {
          "LABEL": "Nimi",
          "PLACEHOLDER": "Kategorian nimi",
          "HELP_TEXT": "Kategorian nimeä ja kuvaketta käytetään julkisessa portaalissa artikkeleiden luokitteluun.",
          "ERROR": "Nimi on pakollinen"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategorian slug URL-osoitteita varten",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug on pakollinen"
        },
        "DESCRIPTION": {
          "LABEL": "Kuvaus",
          "PLACEHOLDER": "Anna lyhyt kuvaus kategoriasta.",
          "ERROR": "Kuvaus on pakollinen"
        },
        "BUTTONS": {
          "CREATE": "Luo kategoria",
          "CANCEL": "Peruuta"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria luotu onnistuneesti",
          "ERROR_MESSAGE": "Kategoriaa ei voitu luoda"
        }
      },
      "EDIT": {
        "TITLE": "Muokkaa kategoriaa",
        "SUB_TITLE": "Kategorian muokkaaminen päivittää kategorian julkisessa portaalissa.",
        "PORTAL": "Portaali",
        "LOCALE": "Kieliversio",
        "NAME": {
          "LABEL": "Nimi",
          "PLACEHOLDER": "Kategorian nimi",
          "HELP_TEXT": "Kategorian nimeä ja kuvaketta käytetään julkisessa portaalissa artikkeleiden luokitteluun.",
          "ERROR": "Nimi on pakollinen"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Kategorian slug URL-osoitteita varten",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug on pakollinen"
        },
        "DESCRIPTION": {
          "LABEL": "Kuvaus",
          "PLACEHOLDER": "Anna lyhyt kuvaus kategoriasta.",
          "ERROR": "Kuvaus on pakollinen"
        },
        "BUTTONS": {
          "CREATE": "Päivitä kategoria",
          "CANCEL": "Peruuta"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria päivitetty onnistuneesti",
          "ERROR_MESSAGE": "Kategoriaa ei voitu päivittää"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategoria poistettu onnistuneesti",
          "ERROR_MESSAGE": "Kategoriaa ei voitu poistaa"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Hae artikkeleita",
      "PLACEHOLDER": "Hae artikkeleita",
      "NO_RESULT": "Artikkeleita ei löytynyt",
      "SEARCHING": "Haetaan...",
      "SEARCH_BUTTON": "Etsi",
      "INSERT_ARTICLE": "Lisää linkki",
      "IFRAME_ERROR": "URL-osoite on tyhjä tai virheellinen. Sisältöä ei voida näyttää.",
      "OPEN_ARTICLE_SEARCH": "Lisää artikkeli Help Centeristä",
      "SUCCESS_ARTICLE_INSERTED": "Artikkeli lisätty onnistuneesti",
      "PREVIEW_LINK": "Esikatsele artikkelia",
      "CANCEL": "Sulje",
      "BACK": "Takaisin",
      "BACK_RESULTS": "Takaisin tuloksiin"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Help Center",
      "DESCRIPTION": "Luo käyttäjäystävällisiä itsepalveluportaaleja. Auta käyttäjiäsi löytämään artikkelit ja saamaan tukea ympäri vuorokauden. Päivitä tilauksesi ottaaksesi tämän ominaisuuden käyttöön.",
      "SELF_HOSTED_DESCRIPTION": "Luo käyttäjäystävällisiä itsepalveluportaaleja. Auta käyttäjiäsi löytämään artikkelit ja saamaan tukea ympäri vuorokauden. Ota yhteyttä pääkäyttäjääsi ottaaksesi tämän ominaisuuden käyttöön.",
      "BUTTON": {
        "LEARN_MORE": "Lue lisää",
        "UPGRADE": "Päivitä"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Useita portaaleja",
          "DESCRIPTION": "Luo useita Help Center -portaaleja eri tuotteille samalla tilillä."
        },
        "LOCALES": {
          "TITLE": "Täysi tuki kieliversioille",
          "DESCRIPTION": "Lokalisoi portaali omalle kielellesi. Tuemme kaikkia kieliversioita ja mahdollistamme käännökset jokaiselle artikkelille."
        },
        "SEO": {
          "TITLE": "SEO-ystävällinen suunnittelu",
          "DESCRIPTION": "Mukauta meta-tunnisteitasi parantaaksesi näkyvyyttäsi hakukoneissa SEO-ystävällisten sivujemme avulla."
        },
        "API": {
          "TITLE": "Täysi API-tuki",
          "DESCRIPTION": "Käytä portaalia headless CMS -järjestelmänä kolmannen osapuolen käyttöliittymäkehysten kanssa API-rajapintojemme avulla."
        }
      }
    },
    "LOADING": "Ladataan...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} katselukerta | {count} katselukertaa",
          "DROPDOWN_MENU": {
            "PUBLISH": "Julkaise",
            "DRAFT": "Draft",
            "ARCHIVE": "Arkistoi",
            "DELETE": "Poista"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Julkaistu",
            "ARCHIVED": "Arkistoitu"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Ei kategoriaa"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Kaikki artikkelit",
          "MINE": "Minun",
          "DRAFT": "Draft",
          "PUBLISHED": "Julkaistu",
          "ARCHIVED": "Arkistoitu"
        },
        "CATEGORY": {
          "ALL": "Kaikki kategoriat"
        },
        "LOCALE": {
          "ALL": "Kaikki kieliversiot"
        },
        "NEW_ARTICLE": "Uusi artikkeli"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Kirjoita artikkeli",
          "SUBTITLE": "Kirjoita monipuolinen artikkeli, aloitetaan!",
          "BUTTON_LABEL": "Uusi artikkeli"
        },
        "MINE": {
          "TITLE": "Et ole vielä kirjoittanut yhtään artikkelia täällä",
          "SUBTITLE": "Kaikki kirjoittamasi artikkelit näkyvät täällä nopeaa pääsyä varten."
        },
        "DRAFT": {
          "TITLE": "Draft-tilassa ei ole artikkeleita",
          "SUBTITLE": "Draft-artikkelit näkyvät täällä"
        },
        "PUBLISHED": {
          "TITLE": "Julkaistuja artikkeleita ei ole",
          "SUBTITLE": "Julkaistut artikkelit näkyvät täällä"
        },
        "ARCHIVED": {
          "TITLE": "Arkistossa ei ole artikkeleita",
          "SUBTITLE": "Arkistoidut artikkelit eivät näy portaalissa. Voit käyttää arkistointia merkitäksesi vanhentuneita tai käytöstä poistettuja sivuja."
        },
        "CATEGORY": {
          "TITLE": "Tässä kategoriassa ei ole artikkeleita",
          "SUBTITLE": "Tämän kategorian artikkelit näkyvät täällä"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Uusi kategoria",
        "EDIT_CATEGORY": "Muokkaa kategoriaa",
        "CATEGORIES_COUNT": "{n} kategoria | {n} kategoriaa",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategoriat ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artikkelia) | {categoryName} ({categoryCount} artikkeli)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Kategorioita ei löytynyt",
        "SUBTITLE": "Kategoriat näkyvät täällä. Voit lisätä kategorian napsauttamalla 'Uusi kategoria' -painiketta."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikkeli | {count} artikkelia",
        "EXPAND": "Näytä alikategoriat",
        "COLLAPSE": "Piilota alikategoriat",
        "MENU": {
          "NEW_ARTICLE": "Uusi artikkeli",
          "ADD_SUBCATEGORY": "Lisää alikategoria",
          "EDIT": "Muokkaa",
          "DELETE": "Poista"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria luotu onnistuneesti",
            "ERROR_MESSAGE": "Kategoriaa ei voitu luoda"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria päivitetty onnistuneesti",
            "ERROR_MESSAGE": "Kategoriaa ei voitu päivittää"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria poistettu onnistuneesti",
            "ERROR_MESSAGE": "Kategoriaa ei voitu poistaa"
          },
          "CONFIRM": {
            "TITLE": "Poista kategoria",
            "DESCRIPTION": "Haluatko varmasti poistaa tämän kategorian? Sen artikkelit jäävät ilman kategoriaa.",
            "DESCRIPTION_WITH_CHILDREN": "Haluatko varmasti poistaa tämän kategorian? Sen artikkelit jäävät ilman kategoriaa, ja sen {count} alikategoria siirretään ylimmälle tasolle. | Haluatko varmasti poistaa tämän kategorian? Sen artikkelit jäävät ilman kategoriaa, ja sen {count} alikategoriaa siirretään ylimmälle tasolle.",
            "CONFIRM": "Poista"
          }
        },
        "HEADER": {
          "CREATE": "Luo kategoria",
          "EDIT": "Muokkaa kategoriaa",
          "DESCRIPTION": "Kategorian muokkaaminen päivittää kategorian julkisessa portaalissa.",
          "PORTAL": "Portaali",
          "LOCALE": "Kieliversio"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nimi",
            "PLACEHOLDER": "Kategorian nimi",
            "ERROR": "Nimi on pakollinen"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Kategorian slug URL-osoitteita varten",
            "ERROR": "Slug on pakollinen",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Kuvaus",
            "PLACEHOLDER": "Anna lyhyt kuvaus kategoriasta.",
            "ERROR": "Kuvaus on pakollinen"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Yläkategoria",
            "PLACEHOLDER": "Valitse yläkategoria",
            "NONE": "Ei mitään (ylin taso)"
          }
        },
        "BUTTONS": {
          "CREATE": "Luo",
          "EDIT": "Päivitä",
          "CANCEL": "Peruuta"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Ei kieliversioita saatavilla | {n} kieliversio | {n} kieliversiota",
      "NEW_LOCALE_BUTTON_TEXT": "Uusi kieliversio",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikkeli | {count} artikkelia",
        "CATEGORIES_COUNT": "{count} kategoria | {count} kategoriaa",
        "DEFAULT": "Oletus",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Aseta oletukseksi",
          "DELETE": "Poista"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Lisää uusi kieliversio",
        "DESCRIPTION": "Valitse kieli, jolla tämä artikkeli kirjoitetaan. Se lisätään käännösluetteloosi, ja voit lisätä niitä myöhemmin lisää.",
        "COMBOBOX": {
          "PLACEHOLDER": "Valitse kieliversio..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Kieliversio lisätty onnistuneesti",
          "ERROR_MESSAGE": "Kieliversiota ei voitu lisätä. Yritä uudelleen."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Tallennetaan...",
          "SAVED": "Tallennettu"
        },
        "PREVIEW": "Esikatselu",
        "PUBLISH": "Julkaise",
        "DRAFT": "Draft",
        "ARCHIVE": "Arkistoi",
        "BACK_TO_ARTICLES": "Takaisin artikkeleihin"
      },
      "DRAFT": {
        "PENDING_LABEL": "Julkaisemattomat muutokset",
        "PROMOTE": "Julkaise muutokset",
        "DISCARD": "Hylkää muutokset",
        "PROMOTE_SUCCESS": "Draft-muutokset julkaistiin artikkeliin",
        "PROMOTE_ERROR": "Draftin muutoksia ei voitu julkaista",
        "DISCARD_SUCCESS": "Draft-muutokset hylättiin",
        "DISCARD_ERROR": "Draftin muutoksia ei voitu hylätä"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versiohistoria",
        "TITLE": "Versiohistoria",
        "BACK": "Takaisin artikkeliin",
        "LOADING": "Ladataan versioita...",
        "EMPTY": "Ei vielä versioita. Tämän artikkelin muokkaukset näkyvät täällä.",
        "EMPTY_CONTENT": "Tässä versiossa ei ole sisältöä.",
        "CURRENT_BADGE": "Nykyinen",
        "RESTORED_BADGE": "Palautettu",
        "AUTOMATED_USER": "Automaattinen päivitys",
        "RESTORE": "Palauta tämä versio",
        "RESTORE_DIALOG": {
          "TITLE": "Palautetaanko tämä versio?",
          "DESCRIPTION": "Artikkeli palautuu tämän version sanamuotoon. Mitään ei menetetä — nykyinen teksti säilyy historiassa, ja julkaistu artikkeli näyttää edelleen nykyisen version, kunnes julkaiset muutoksen.",
          "CONFIRM": "Palauta"
        },
        "RESTORE_SUCCESS": "Versio palautettu",
        "RESTORE_ERROR": "Tätä versiota ei voitu palauttaa",
        "FETCH_ERROR": "Versiohistoriaa ei voitu ladata"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Näytä ominaisuudet",
        "TRANSLATE": "Käännä",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Ei kategoriaa",
        "EDITOR_PLACEHOLDER": "Kirjoita jotain...",
        "HTML_EMBED": {
          "TITLE": "Lisää mukautettu HTML",
          "DESCRIPTION": "Liitä raakaa HTML-koodia, kuten iframe, upotus tai widget-katkelma. Se näytetään sellaisenaan julkaistussa artikkelissa.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Lisää"
        },
        "PRIMARY_CATEGORY": "Pääkategoria"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikkelin ominaisuudet",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta-kuvaus",
        "META_DESCRIPTION_PLACEHOLDER": "Lisää meta-kuvaus",
        "META_TITLE": "Meta-otsikko",
        "META_TITLE_PLACEHOLDER": "Lisää meta-otsikko",
        "META_TAGS": "Meta-tunnisteet",
        "META_TAGS_PLACEHOLDER": "Lisää meta-tunnisteet",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Kieliversiot",
        "LANGUAGE_MUTATIONS_EMPTY": "Ei linkitettyjä artikkeleita",
        "ADD_MUTATION": "Lisää",
        "REMOVE_MUTATION": "Poista"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Linkitä kieliversiot",
        "SEARCH_PLACEHOLDER": "Hae artikkeleita otsikon mukaan",
        "EMPTY": "Ei vastaavia artikkeleita",
        "CANCEL": "Peruuta",
        "ADD_SELECTED": "Lisää valitut",
        "SUCCESS": "Versiot päivitetty",
        "ERROR": "Versioiden päivitys epäonnistui"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Käännä artikkeli",
        "DESCRIPTION": "Valitse kielet, joille haluat kääntää tämän artikkelin. Jo käännetyt kielet käännetään uudelleen Draft-tilaan tarkistettavaksi.",
        "EMPTY": "Muita kieliä ei ole saatavilla.",
        "CONNECTED_BADGE": "Käännetty",
        "CANCEL": "Peruuta",
        "TRANSLATE": "Käännä",
        "SUCCESS": "Käännös alkaa pian. Käännetyt artikkelit näkyvät pian kieliversioina.",
        "ERROR": "Käännöksen aloittaminen epäonnistui"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Virhe artikkelin tallentamisessa"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Uusi portaali",
      "PORTALS": "Portaalit",
      "CREATE_PORTAL": "Luo ja hallitse useita portaaleja",
      "ARTICLES": "artikkelia",
      "DOMAIN": "verkkotunnus",
      "PORTAL_NAME": "Portaalin nimi"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Luo uusi portaali",
      "DESCRIPTION": "Anna portaalillesi nimi ja luo käyttäjäystävällinen URL-slug. Voit muokata molempia myöhemmin asetuksista.",
      "CONFIRM_BUTTON_LABEL": "Luo",
      "NAME": {
        "LABEL": "Nimi",
        "PLACEHOLDER": "Käyttöopas",
        "MESSAGE": "Valitse nimi portaalillesi.",
        "ERROR": "Nimi on pakollinen"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug on pakollinen",
        "FORMAT_ERROR": "Käytä vain kirjaimia, numeroita ja yhdysmerkkejä, esimerkiksi: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Kuvaa ei voitu ladata! Yritä uudelleen",
          "IMAGE_UPLOAD_SUCCESS": "Kuva lisätty onnistuneesti. Napsauta 'Tallenna muutokset' tallentaaksesi logon",
          "IMAGE_DELETE_SUCCESS": "Logo poistettu onnistuneesti",
          "IMAGE_DELETE_ERROR": "Logoa ei voitu poistaa",
          "IMAGE_UPLOAD_SIZE_ERROR": "Kuvan koon tulee olla alle {size}Mt"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nimi",
          "PLACEHOLDER": "Portaalin nimi",
          "ERROR": "Nimi on pakollinen"
        },
        "HEADER_TEXT": {
          "LABEL": "Ylätunnisteen teksti",
          "PLACEHOLDER": "Portaalin ylätunnisteen teksti"
        },
        "PAGE_TITLE": {
          "LABEL": "Sivun otsikko",
          "PLACEHOLDER": "Portaalin sivun otsikko"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Etusivun linkki",
          "PLACEHOLDER": "Portaalin etusivun linkki",
          "ERROR": "Virheellinen URL-osoite. Etusivun linkin tulee alkaa 'http://' tai 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portaalin slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live-chat-widget",
          "PLACEHOLDER": "Valitse live-chat-widget",
          "HELP_TEXT": "Valitse live-chat-widget, joka näkyy Help Centerissäsi"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Julkisesti saatavilla",
          "HELP_TEXT": "Tee portaali kaikkien saataville linkillä.",
          "OPTIONS": {
            "PUBLIC": "Kyllä",
            "PRIVATE": "Ei"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Linkin kohde",
          "HELP_TEXT": "Valitse, avautuvatko artikkelien linkit nykyisessä ikkunassa vai uudessa.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Nykyinen ikkuna",
            "NEW_WINDOW": "Uusi ikkuna"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Kuvan oletuskoko",
          "HELP_TEXT": "Koko, jota käytetään jokaiseen artikkeliin lisäämääsi kuvaan. Valitse Original, jos haluat lisätä kuvat niiden omassa koossa ja valita koon kuvakohtaisesti."
        },
        "BRAND_COLOR": {
          "LABEL": "Brändiväri"
        },
        "CUSTOM_HTML": {
          "LABEL": "Mukautettu HTML",
          "PLACEHOLDER": "<!-- Liitä analytiikka- tai seurantakoodinpätkäsi tähän -->",
          "HELP_TEXT": "Lisätään jokaisen Help Center -sivun <body>-tunnisteen alkuun. Käytä sitä Google Analyticsia, Google Tag Manageria tai mitä tahansa muuta seurantakoodia varten. Koodi näytetään täsmälleen sellaisena kuin se on syötetty, eikä sitä validoida."
        },
        "SAVE_CHANGES": "Tallenna muutokset"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Mukautettu verkkotunnus",
          "LABEL": "Mukautettu verkkotunnus:",
          "DESCRIPTION": "Voit isännöidä portaaliasi mukautetussa verkkotunnuksessa. Jos verkkosivustosi on esimerkiksi yourdomain.com ja haluat portaalisi olevan saatavilla osoitteessa docs.yourdomain.com, syötä se tähän kenttään.",
          "PLACEHOLDER": "Portaalin mukautettu verkkotunnus",
          "EDIT_BUTTON": "Muokkaa mukautettua verkkotunnusta",
          "ADD_BUTTON": "Lisää mukautettu verkkotunnus",
          "DIALOG": {
            "ADD_HEADER": "Lisää mukautettu verkkotunnus",
            "EDIT_HEADER": "Muokkaa mukautettua verkkotunnusta",
            "ADD_CONFIRM_BUTTON_LABEL": "Lisää verkkotunnus",
            "EDIT_CONFIRM_BUTTON_LABEL": "Päivitä verkkotunnus",
            "LABEL": "Mukautettu verkkotunnus",
            "PLACEHOLDER": "Portaalin mukautettu verkkotunnus",
            "ERROR": "Mukautettu verkkotunnus on pakollinen"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-määritykset",
            "DESCRIPTION": "Kirjaudu sisään DNS-palveluntarjoajasi tilille ja lisää alla oleva CNAME-tietue alitunnuksellesi.",
            "HELP_TEXT": "Kun tämä on tehty, voit ottaa yhteyttä tukeemme pyytääksesi automaattisesti luodun SSL-varmenteen.",
            "CONFIRM_BUTTON_LABEL": "Selvä!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Poista {portalName}",
          "HEADER": "Poista portaali",
          "DESCRIPTION": "Poista tämä portaali pysyvästi. Tätä toimintoa ei voi peruuttaa",
          "DIALOG": {
            "HEADER": "Haluatko varmasti poistaa kohteen {portalName}?",
            "DESCRIPTION": "Tämä on pysyvä toiminto, jota ei voi peruuttaa.",
            "CONFIRM_BUTTON_LABEL": "Poista"
          }
        },
        "EDIT_CONFIGURATION": "Muokkaa määrityksiä"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portaali luotu onnistuneesti",
          "ERROR_MESSAGE": "Portaalia ei voitu luoda"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portaali päivitetty onnistuneesti",
          "ERROR_MESSAGE": "Portaalia ei voitu päivittää"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Liitteet",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Lisää tiedosto",
      "DROP_HERE": "Vedä ja pudota tiedostot tähän",
      "COPY_LINK": "Kopioi linkki",
      "LINK_COPIED": "Linkki kopioitu leikepöydälle",
      "COPY_FAILED": "Linkin kopiointi epäonnistui",
      "DELETE": "Poista",
      "CANCEL": "Peruuta",
      "QUEUED": "Jonossa",
      "UPLOADING": "Ladataan",
      "UPLOAD_FAILED": "Tiedoston lataus epäonnistui",
      "FILE_TOO_LARGE": "Tiedosto ylittää 40 Mt:n kokorajan"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Käännössanasto",
        "DESCRIPTION": "Tässä määritellyt termit lisätään AI-käännöksen kehotteeseen, jotta ne käännetään aina samalla tavalla. Avaintermi on kirjoitettu kielellä {locale}."
      },
      "NEW_TERM": "Uusi termi",
      "EMPTY_STATE": {
        "TITLE": "Sanastossa ei ole vielä termejä",
        "SUBTITLE": "Lisää termi ja sen käännös jokaiselle kielelle. Kun artikkeli käännetään, näitä termejä noudatetaan, jotta tuotteesi sanasto pysyy yhtenäisenä."
      },
      "LIST": {
        "TERM": "Termi",
        "TRANSLATIONS": "Käännökset",
        "ACTIONS": "Toiminnot"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Lisää termi",
          "EDIT": "Muokkaa termiä",
          "DESCRIPTION": "Alla olevaa termiä noudatetaan, kun Help Center -artikkeleitasi käännetään AI:n avulla.",
          "PORTAL": "Portaali",
          "PRIMARY_LANGUAGE": "Ensisijainen kieli"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termi ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Termi on pakollinen"
          },
          "DESCRIPTION": {
            "LABEL": "Konteksti / muistiinpanot (valinnainen)",
            "PLACEHOLDER": "Milloin ja miten tätä termiä käytetään, jotta kääntäjän on helpompi täsmentää sen merkitys."
          },
          "TRANSLATIONS": "Käännökset",
          "TRANSLATION_PLACEHOLDER": "Jätä tyhjäksi, jos haluat AI:n kääntävän vapaasti",
          "AUTO_TRANSLATE": {
            "BUTTON": "Käännä kaikki automaattisesti",
            "CONFIRM": "Käännä {count} kielelle AI:n avulla?",
            "CONFIRM_BUTTON": "Käännä",
            "CANCEL": "Peruuta",
            "SUCCESS": "Käännökset luotu — tarkista ja tallenna",
            "ERROR": "Automaattikäännös epäonnistui, yritä uudelleen"
          }
        },
        "BUTTONS": {
          "CREATE": "Lisää termi",
          "EDIT": "Tallenna",
          "CANCEL": "Peruuta"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termi lisätty onnistuneesti",
            "ERROR_MESSAGE": "Termiä ei voitu lisätä, yritä uudelleen"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termi päivitetty onnistuneesti",
            "ERROR_MESSAGE": "Termiä ei voitu päivittää, yritä uudelleen"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Poista termi",
          "DESCRIPTION": "Haluatko varmasti poistaa tämän termin? Sitä ei enää noudateta käännöksen aikana.",
          "CONFIRM": "Poista"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termi poistettu onnistuneesti",
          "ERROR_MESSAGE": "Termiä ei voitu poistaa, yritä uudelleen"
        }
      }
    }
  }
}
